import React, { useMemo } from "react";
import { DraggableSection } from "./Components";
import { RootState } from "us.helper/types";
import { connect, ConnectedProps } from "react-redux";
import _, { isArray } from "lodash";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { getUrlParams } from "components/EditorHome/Functions";
import { getTemplateGroupName } from "functions/EditorHome";
import { DocumentType } from "./Contstants";
import { getSectionsByGroup } from "functions/TemplateEditor";

const SectionPicker: React.FC<PropsFromRedux> = (props) => {
  const { templates } = props;
  const { t } = useTranslation();
  const { search } = useLocation();
  const { groupId, documentType } = getUrlParams(search);

  const groupName = useMemo(() => {
    return getTemplateGroupName(templates.groups, groupId);
  }, [groupId, templates.groups]);

  const sections = useMemo(() => {
    return getSectionsByGroup(groupName);
  }, [groupName]);

  return (
    <>
      <div className="panel-title pr-1">
        <h4 className="d-flex align-items-center pl-2 py-2 m-0">
          {t("US.USC.TEMPLATEEDITOR:TEMPLATE_EDITOR.SECTIONS")}
        </h4>
      </div>

      <div className="components-content p-2 mb-2">
        {isArray(sections) &&
          sections.map((section, index) => {
            return (
              <DraggableSection
                key={section.name + index}
                section={section}
                disabled={documentType == DocumentType.EMAIL}
              />
            );
          })}
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  const { templatesHistory } = state;
  const { templates } = templatesHistory;

  return {
    templates,
  };
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(SectionPicker);
